import { Inline } from '@bedrock-layout/primitives';
import styled from 'styled-components';

export const ArrowNodeContainer = styled(Inline)`
  inline-size: 8rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;
